"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBAuthFrame = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var bb_post_message_1 = require("bb-auth-frame/bb-post-message");
var builtinIframeStyles = {
    width: "100%",
    height: "100%",
    border: "none",
};
var builtinContainerStyles = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "#333",
    backgroundColor: "rgba(51, 51, 51, 0.2)",
    zIndex: 2,
};
/**
 * A component that wraps the bb-auth-frame iframe and handles token passing
 *
 * To use you must provide:
 * - an onAuthSuccess handler which will be passed an AuthResult object when authorization and authentication is successfull
 * The AuthResult object will contain cognito tokesn. The authResult.AccessToken value can be used as the Token header value in requests to bb-platform services.
 * - the last result returned from onAuthSuccess OR null
 *
 * @param {Props} props
 * @returns
 */
function BBAuthFrame(_a) {
    var _b = _a.environment, environment = _b === void 0 ? "prod" : _b, _c = _a.tokens, tokens = _c === void 0 ? null : _c, _d = _a.guestAccountMode, guestAccountMode = _d === void 0 ? false : _d, _e = _a.compact, compact = _e === void 0 ? false : _e, _f = _a.startInCreateMode, startInCreateMode = _f === void 0 ? false : _f, className = _a.className, _g = _a.containerStyles, containerStyles = _g === void 0 ? {} : _g, _h = _a.iframeStyles, iframeStyles = _h === void 0 ? {} : _h, onAuthSuccess = _a.onAuthSuccess, onAuthFail = _a.onAuthFail, _j = _a.refreshMode, refreshMode = _j === void 0 ? false : _j, _k = _a.logoutMode, logoutMode = _k === void 0 ? false : _k;
    var frameRef = (0, react_1.useRef)(null);
    var src = null;
    var path;
    if (logoutMode) {
        path = "/logout-redirect";
    }
    else if (refreshMode) {
        path = "/refresh";
        if (guestAccountMode) {
            path += "-guest";
        }
    }
    else if (guestAccountMode) {
        path = "/guest-login";
    }
    else if (startInCreateMode) {
        path = "/create-account";
    }
    else {
        path = "";
    }
    if (compact) {
        path += "?compact=true";
    }
    if (environment.toLowerCase() === "prod") {
        src = "https://bb-auth.buildbox.com".concat(path);
    }
    else if (environment.toLowerCase() === "dev") {
        src = "https://bb-auth.dev.8cell.com".concat(path);
    }
    else if (environment.toLowerCase() === "local") {
        src = "http://localhost:8888".concat(path);
    }
    else {
        src = null;
    }
    (0, react_1.useEffect)(function () {
        if (frameRef.current === null) {
            return function () { };
        }
        var postMessageClient = new bb_post_message_1.BBPostMessageClient(environment, frameRef.current.contentWindow, src);
        postMessageClient.addListener(bb_post_message_1.MessageTypes.AUTH_RESULT, function (_a) {
            var payload = _a.payload;
            if (payload.successful) {
                onAuthSuccess(payload);
            }
            else {
                onAuthFail(payload.message);
            }
        });
        return function () {
            postMessageClient.unregister();
        };
    }, [frameRef, onAuthSuccess, onAuthFail]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: className, style: __assign(__assign({ display: tokens === null ? "block" : "none" }, builtinContainerStyles), containerStyles) }, { children: [src !== null ? ((0, jsx_runtime_1.jsx)("iframe", { style: __assign(__assign({}, builtinIframeStyles), iframeStyles), ref: frameRef, src: src })) : undefined, src === null ? (0, jsx_runtime_1.jsx)("div", { children: "Something went wrong" }) : undefined] })));
}
exports.BBAuthFrame = BBAuthFrame;
